/* eslint-disable max-classes-per-file */
import { Expose, Type, Transform } from 'class-transformer'

import { TagType } from '@models/story/TagType'
import { BookNewChapterType } from '@models/myReading/BookNewChapterType'
import { CategoryType } from '@models/category/CategoryType'
import { BookEnum } from '@interfaces/BookEnum'
import { AffiliationEnum } from '@interfaces/AffiliationEnum'
import { WriterStatusEnum } from '@interfaces/WriterStatusEnum'
import { WritingEnum } from '@interfaces/WritingEnum'
import { BookBuyAllChapterPromotion } from '@models/book/BookBuyAllChapterPromotion'
import { BookReadFreePromotion } from '@models/book/BookReadFreePromotion'
import { BookBadge } from '@models/book/BookBadge'

class WriterType {
  @Expose()
  affiliation: AffiliationEnum

  @Expose()
  status: WriterStatusEnum
}

class UserType {
  @Expose() id: number

  @Expose() displayName: string

  @Expose() profilePageSlug: string

  @Expose()
  @Type(() => WriterType)
  @Transform(({ value }) => value || {})
  writer: WriterType
}

class PenNameType {
  @Expose() firstPenName: string

  @Expose()
  @Type(() => UserType)
  user: UserType
}

export class BookCardType {
  @Expose() id: number

  @Expose() title: string

  @Expose({ name: 'coverImgPath' }) image: string

  @Expose() coverResizeImgPath: string

  @Expose() writer: string

  @Expose()
  @Type(() => PenNameType)
  penName: PenNameType

  @Expose({ name: 'cover' }) content: string

  @Expose() category: CategoryType

  @Expose() isTranslated: boolean

  @Expose({ toClassOnly: true })
  @Type(() => TagType)
  tags: TagType[]

  @Expose() viewCount: number

  @Expose() commentCount: number

  @Expose() likeCount: number

  @Expose() isEnded: boolean

  @Expose() bookType: BookEnum

  @Expose() newChapter: BookNewChapterType

  @Expose({ name: 'publishedChapterCount' }) chapterCount: number

  @Expose() chapterPurchasedCount: number

  @Expose() isLiked: boolean

  @Expose()
  @Transform(({ obj }) => obj.penName?.user?.displayName || '')
  displayName: string

  @Expose()
  @Transform(
    ({ obj }) =>
      obj.penName.user?.writer?.affiliation === AffiliationEnum.PUBLISHER &&
      obj.penName.user?.writer?.status === WriterStatusEnum.APPROVED
  )
  isPublisher: boolean

  @Expose()
  @Transform(({ obj }) =>
    obj.bookChapters?.length ? obj.bookChapters[0].chapterName : undefined
  )
  chapterName?: string

  @Expose()
  @Transform(({ obj }) =>
    obj.bookChapters?.length ? obj.bookChapters[0].id : undefined
  )
  chapterId?: number

  @Expose()
  @Transform(({ obj }) => obj?.category?.name)
  categoryName: string

  @Expose()
  @Transform(({ obj }) => obj?.category?.id)
  categoryId: number

  @Expose() writingType: WritingEnum

  @Expose() publishedAt: string

  @Expose() isEpub: boolean

  @Expose() isPdf: boolean

  @Expose() hasSalePromotions?: boolean

  @Expose()
  @Type(() => BookBuyAllChapterPromotion)
  buyAllChaptersPromotion?: BookBuyAllChapterPromotion

  @Expose()
  @Type(() => BookReadFreePromotion)
  readFreePromotion?: BookReadFreePromotion

  @Expose()
  @Type(() => BookBadge)
  bookBadges?: BookBadge[]
}
